// Frontend mirror of supabase/functions/_shared/llm-presets.ts — keep in sync.
export type PresetKey =
  | "groq" | "openai" | "anthropic_compat" | "humain" | "vllm_selfhosted" | "custom";

export interface PresetDef { label: string; baseUrl: string; suggestedModel: string; keyless: boolean; }

export const LLM_PRESETS: Record<PresetKey, PresetDef> = {
  groq: { label: "Groq", baseUrl: "https://api.groq.com/openai/v1", suggestedModel: "openai/gpt-oss-120b", keyless: false },
  openai: { label: "OpenAI", baseUrl: "https://api.openai.com/v1", suggestedModel: "gpt-4o-mini", keyless: false },
  anthropic_compat: { label: "Anthropic (OpenAI-compatible proxy)", baseUrl: "", suggestedModel: "claude-sonnet-4-5", keyless: false },
  humain: { label: "HUMAIN", baseUrl: "https://api.node.humain.com/v1", suggestedModel: "humain-m3-preview", keyless: false },
  vllm_selfhosted: { label: "Self-hosted vLLM", baseUrl: "", suggestedModel: "", keyless: true },
  custom: { label: "Custom OpenAI-compatible", baseUrl: "", suggestedModel: "", keyless: false },
};
